<script>
import { authService } from '@/src/services/safehaven/AuthService'

export default {
  data() {
    return {
      org: null,
    }
  },
  computed: {
    showLogo() {
      // return true
      return this.$route.meta.showLogo
    },
    signUpContainerWidth() {
      return this.$route?.meta.signup
    },
  },
  mounted() {
    this.getOrgDetails()
  },
  methods: {
    getOrgDetails() {
      const orgName = this.$route.params.clientId
        ? this.$route.params.clientId.toLowerCase()
        : 'healthbook'
      authService.getLogo(orgName).then(
        (res) => {
          this.org = res.data
          localStorage.setItem('organisationDetails', JSON.stringify(res.data))
        },
        (err) => {
          if (
            err.response?.data &&
            err.response.data.org === 'Organization not found'
          ) {
            this.$router.push({
              name: '404',
              params: {
                clientId: this.$route.params.clientId
                  ? this.$route.params.clientId
                  : 'healthbook',
              },
            })
          }
        }
      )
    },
  },
}
</script>

<template>
  <v-container
    id="safehaven"
    fluid
    :class="showLogo ? $style.container : $style.welcomeContainer"
    fill-height
  >
    <div
      :class="
        signUpContainerWidth ? $style.signUpContainer : $style.innerContainer
      "
    >
      <div v-if="showLogo && org" class="mt-10" align="center">
        <img :class="$style.logo" :src="org.logo_url" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.innerContainer {
  width: 32%;
  margin: auto;
  background-color: white;
  border-radius: 9px;
}
.innerContainer404 {
  width: 100%;
}
.container404 {
  padding: 0 !important;
}

.signUpContainer {
  width: 50%;
  margin: auto;
  background-color: white;
  border-radius: 9px;
}

.container {
  width: 100%;
  height: 100%;
  padding: 4%;
  margin: auto;
  background-image: url('~@assets/images/safehaven/Background-Blue-Signin.jpg');
}

.welcomeContainer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.logo {
  width: 85%;
  height: auto;
}

@media screen and (max-width: 600px) {
  .innerContainer,
  .signUpContainer {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }

  .container,
  .welcomeContainer {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: white;
    background-image: none;
  }
}

@media screen and (min-width: 601px) and (max-width: 1080px) {
  .innerContainer,
  .signUpContainer {
    width: 46%;
  }
}

@media screen and (min-width: 1080px) and (max-width: 1250px) {
  .logo {
    width: 250px;
    height: auto;
  }
}

@media screen and (min-width: 1250px) and (max-width: 1400px) {
  .logo {
    width: 300px;
    height: auto;
  }
}
</style>
